module.exports = __webpack_public_path__ + "static/media/cruise.c4dbdc73.jpg";